<template>
  <span v-if="canInstantInvite">
    <slot :showModal="showModal"></slot>
  </span>
</template>

<script>
import store from '@/lib/store'
import { create } from 'vue-modal-dialogs'
import InstantInviteModal from './InstantInviteModal'

const showModal = create({
  component: InstantInviteModal
})

export default {
  components: {
    InstantInviteModal
  },
  data () {
    return {
      user: store.get('user')
    }
  },
  computed: {
    canInstantInvite () {
      const isUserOrAbove = this.user.roles.some((role) => ['user', 'manager', 'admin', 'owner'].includes(role.name))
      return isUserOrAbove
    }
  },
  methods: {
    showModal () {
      showModal()
    }
  }
}
</script>



// WEBPACK FOOTER //
// InstantInviteModalTrigger.vue?7f5283dc